import React from 'react';

export default function WorkTypeTabBar({ details, currentTab, onTabChange }) {
  return (
    <section className="sticky top-0 z-40 -mx-5 border-b border-[#becab7]/10 bg-[#f8f9fb]/95 px-5 backdrop-blur-sm">
      <div className="no-scrollbar flex gap-1 overflow-x-auto">
        {details?.map((item) => {
          const isSelected = String(currentTab) === String(item.workItemId);
          return (
            <button
              key={item.dtlCd}
              onClick={() => onTabChange(String(item.workItemId))}
              className={`flex-none rounded-full px-5 py-2 text-xs font-bold transition-all duration-200 ${
                isSelected
                  ? 'bg-[#5ABD4F] text-white shadow-lg shadow-[#5ABD4F]/20'
                  : 'border border-[#becab7]/30 bg-white text-[#3f4a3b]'
              }`}
            >
              {item.workTypeNm} {item?.isExtended === 'Y' && '(연장)'}
            </button>
          );
        })}
      </div>
    </section>
  );
}
